import 'index.css';
import './VideoPlayer.scss';

import React, {Component} from 'react';

import Conf from 'utils/Conf';
import Controls from 'components/Controls/Controls';
import Context from 'utils/Context';
import Loader from 'components/Loader';
import Retard from 'components/Retard';
import Vimeo from '@u-wave/react-vimeo';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
momentDurationFormatSetup(moment);

class VideoPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paused: !props.paused,
      actuallyPaused: true,
      position: 0,
      currentTime: 0,
      duration: null,
      ready: false,
      showMask: true,
      controlled: !!props.onPlayRequest,
      show: false,
      width: 1920,
      height: 1080,
      direct: 0,
      retard: 0,
    };
    this.handleTogglePlay = this.handleTogglePlay.bind(this);
    this.handlePlay = this.handlePlay.bind(this);
    this.handleReady = this.handleReady.bind(this);
    this.handlePause = this.handlePause.bind(this);
    this.handleMute = this.handleMute.bind(this);
    this.handleUnMute = this.handleUnMute.bind(this);
    this.handleVolumeChange = this.handleVolumeChange.bind(this);
    this.handleTimeUpdate = this.handleTimeUpdate.bind(this);
    this.handlePositionUpdate = this.handlePositionUpdate.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.directTick = this.directTick.bind(this);
    this.onPause = this.onPause.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onEnd = this.onEnd.bind(this);
    this.playTick = 0;
    this.interval = 0;
    this.playerRef = React.createRef();
    this.wrapperRef = React.createRef();
  }
  componentDidMount() {
    this.interval = setInterval(this.directTick, 500);
  }
  componentWillUnmount() {
    clearTimeout(this.timeoutId);
    clearInterval(this.interval);
  }
  getPaused() {
    return this.state.controlled ? this.props.paused : this.state.paused;
  }
  handleMouseMove(e) {
    clearTimeout(this.timeoutId);
    if (!this.state.show) {
      this.setState({show: true});
      this.props.onShowControls && this.props.onShowControls();
    }
    this.timeoutId = setTimeout(() => {
      this.setState({show: false});
      this.props.onHideControls && this.props.onHideControls();
    }, Conf.timeBeforeFade);
  }
  handleMouseLeave(e) {
    clearTimeout(this.timeoutId);
    this.setState({show: false});
    this.props.onHideControls && this.props.onHideControls();
  }
  handleTogglePlay(e) {
    if (e) e.stopPropagation();
    if (!this.state.controlled) {
      this.setState({
        paused: !this.getPaused(),
      });
    } else {
      this.props.onTogglePlayRequest();
    }
  }
  handlePlay(e) {
    if (e) e.stopPropagation();
    if (!this.state.controlled) {
      this.setState({
        paused: false,
      });
    } else {
      this.props.onPlayRequest();
    }
  }
  handlePause(e) {
    if (e) e.stopPropagation();
    let {direct, duration, currentTime} = this.state;
    let {appState} = this.context;
    let retard = direct * duration - currentTime;
    if (direct) {
      if (retard > appState?.conf.RETARD_MAX * 60) {
        return;
      }
    }
    if (!this.state.controlled) {
      this.setState({
        paused: true,
      });
    } else {
      this.props.onPauseRequest();
    }
  }
  handleMute(e) {
    if (e) e.stopPropagation();
    let state = {volume: 0};
    this.context.methods.setAppState(state);
  }
  handleUnMute(e) {
    if (e) e.stopPropagation();
    let state = {volume: this.context.appState.currentVolume};
    this.context.methods.setAppState(state);
  }
  handleVolumeChange(v) {
    let state = {volume: v, currentVolume: v};
    this.context.methods.setAppState(state);
  }
  handleReady(player) {
    this.player = player;
    Promise.all([player.getVideoWidth(), player.getVideoHeight(), player.getDuration()])
      .then(infos => {
        let width = infos[0];
        let height = infos[1];
        let duration = infos[2];
        this.setState({
          width: width,
          height: height,
          duration: duration,
          ready: true,
        });
        if (this.props.onReady) this.props.onReady(duration);
        if (this.props.startTimecode) this.handlePositionUpdate(this.props.startTimecode / duration);
      })
      .catch(error => {
        return;
      });
  }

  handleError = error => {
    if (error.status === 304) {
      // TODO: get player
      // this.handleReady(player);
      // 304 is not a real error, it should be handled as a success
    } else if (this.props.onError) {
      this.props.onError(error);
    }
  };
  handleTimeUpdate(e) {
    if (this.props.onTimeUpdate) this.props.onTimeUpdate(e.seconds);
    if (this.getPaused()) this.player.pause();
    let showMask = this.state.showMask;
    if (this.state.duration - e.seconds < 1 || e.seconds < 0.2) showMask = true;
    else showMask = false;
    this.setState({
      currentTime: e.seconds,
      showMask: showMask,
      showLoader: false,
    });
    this.props.isFilm && this.props.onTick(this.props.video, e.seconds);
  }
  directTick() {
    let {duration, paused, currentTime} = this.state;
    let {isFilm, startTime} = this.props;
    const {appState} = this.context;
    let direct = isFilm && Math.max(0, moment().diff(startTime, 'seconds')) / duration;
    if (direct) {
      let retard = direct * duration - currentTime;
      if (paused && retard > appState?.conf.RETARD_MAX * 60) {
        this.handlePlay();
      }
      this.setState({
        direct,
        paused,
        retard,
      });
    }
  }
  handlePositionUpdate(p) {
    let pauseState = this.getPaused();
    this.handlePause();
    this.setState({
      currentTime: p * this.state.duration,
      showLoader: true,
    });
    this.player.setCurrentTime(Math.min(this.state.duration - 5, Math.min(p * this.state.duration))).then(() => {
      if (!pauseState) this.handlePlay();
    });
  }
  onPlay() {
    this.setState({
      paused: false,
      actuallyPaused: false,
    });
    this.props.onPlay();
  }
  onPause() {
    this.setState({
      paused: true,
      actuallyPaused: true,
    });
    this.props.onPause();
  }
  onEnd() {
    this.setState({
      paused: true,
      showMask: true,
    });
    this.player.setCurrentTime(0);
    this.props.onEnd();
  }
  render() {
    // Video player declaration
    let paused = this.getPaused();
    if (this.props.mustPause) paused = true;
    let video = '';
    if (this.props.video)
      video = (
        <Vimeo
          video={`https://vimeo.com/${this.props.video}`}
          controls={false}
          paused={paused}
          volume={this.context.appState?.volume}
          autoplay={this.props.autoplay}
          onPause={this.onPause}
          onPlay={this.onPlay}
          onReady={this.handleReady}
          onError={this.handleError}
          onEnd={this.onEnd}
          onTimeUpdate={e => this.handleTimeUpdate(e)}
          responsive
        />
      );
    let controlsClasses = 'videoplayer-controls';
    if (!this.props.hideControls && (this.state.show || paused)) controlsClasses += ' show';
    let maskClasses = 'videoplayer-black';
    if (this.state.showMask) maskClasses += ' show';
    //player
    let wrapperRatio = 1920 / 1080;
    let playerRatio = 1920 / 1080;
    let scale = 1;
    if (this.wrapperRef.current) {
      wrapperRatio = Math.max(wrapperRatio, this.wrapperRef.current.clientWidth / this.wrapperRef.current.clientHeight);
      if (wrapperRatio > playerRatio) {
        scale = playerRatio / wrapperRatio;
      }
    }
    //video
    let ratio = this.state.width / this.state.height;
    let videoWidth = (scale * ratio * 900) / 16;
    let videoLeft = (100 - videoWidth) / 2;
    let style = {};
    if (ratio < 16 / 9) {
      style = {width: videoWidth + '%', left: videoLeft + '%'};
    }
    // if (ratio > 16 / 9) {
    //     style = { height: videoHeight + "%", top: videoTop + "%" };
    // }
    let countdown = moment
      .duration(this.context.appState?.conf.RETARD_MAX * 60 - this.state.retard, 'seconds')
      .format('h[h]mm[m]ss[s]');

    const isNewVimeoEvent = this.props.video && this.props.video.includes('event/');

    return (
      <div className="videoplayer-wrapper" ref={this.wrapperRef}>
        <div className="videoplayer-container" style={{width: scale * 100 + '%'}}>
          <div
            ref={this.playerRef}
            className="videoplayer"
            onMouseDown={this.handleMouseMove}
            onMouseMove={this.handleMouseMove}
            onMouseLeave={this.handleMouseLeave}
          >
            <div className="videoplayer-inner">
              <div className="videoplayer-inner-video-container" style={style}>
                {video}
              </div>
              {!isNewVimeoEvent && (
                // Add custom
                <div className="videoplayer-mask" onClick={this.handleTogglePlay}>
                  {!this.props.isLive && <div className={maskClasses}></div>}
                  <Loader
                    className="videoplayer-loader"
                    loading={this.props.video && ((!paused && this.state.actuallyPaused) || this.state.showLoader)}
                  />
                  {this.state.currentTime > 0 && (
                    <Retard
                      className="videoplayer-retard"
                      show={paused && this.state.retard > 0}
                      countdown={countdown}
                    />
                  )}
                  {this.state.ready && (
                    <div className={controlsClasses}>
                      <Controls
                        playerState={this.state}
                        volume={this.context.appState?.volume}
                        paused={paused}
                        onPlay={this.handlePlay}
                        onPause={this.handlePause}
                        onMute={this.handleMute}
                        onUnMute={this.handleUnMute}
                        onPositionUpdate={this.handlePositionUpdate}
                        onVolumeChange={this.handleVolumeChange}
                        node={this.props.node ? this.props.node : this.wrapperRef.current}
                        moveDisabled={this.props.moveDisabled}
                        onExitfullscreen={this.props.onExitfullscreen}
                        fullScreenDisabled={this.props.fullScreenDisabled}
                        direct={this.state.direct}
                        directMin={
                          (this.state.direct * this.state.duration - this.context.appState?.conf.RETARD_MAX * 60) /
                          this.state.duration
                        }
                        visibleTimestamp={this.props.isFilm}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

VideoPlayer.contextType = Context;

export default VideoPlayer;
